import React from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import CmsTools from '../../../CmsTools/CmsTools';
import { isMobile, isMobileSafari } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

const Pdf = ({ id }) => {
  const dispatch = useDispatch();
  const {
    dataUrlBase,
    courseId,
    assetManifest,
    dataUrl,
    language
  } = useSelector(
    state => ({
      courseId: state.CourseState.courseId,
      dataUrlBase: state.CourseState.dataUrlBase,
      assetManifest: state.BlockState.assetManifest,
      dataUrl: state.BlockState.dataUrl,
      language: state.CourseState.language
    }),
    shallowEqual
  );
  const { t } = useTranslation();

  let asset = assetManifest.assets.find(a => a.id === id || a.importId === id);
  let localizedFile =
    language.code === 'en-US'
      ? asset.file
      : asset.file.replace('.pdf', `_${language.code}.pdf`);
  let hideOpen = false;
  if (asset.metadata && asset.metadata['is-html-lab']) {
    localizedFile = asset.file.replace('.pdf', `.html`);
    hideOpen = asset.metadata['is-html-lab'];
  }
  return (
    <div style={{ margin: '0 10% 15px', position: 'relative' }}>
      <CmsTools id={id} type="assets" subtype="pdf" />
      {asset ? (
        <button
          style={{ maxWidth: '100%', width: '100%' }}
          title={asset.description}
          className={`btn btn--${
            asset.subtype === 'lab' ? 'success' : 'secondary'
          } btn--wide`}
          onClick={() => {
            if (isMobile || isMobileSafari) {
              window.open(
                `${
                  asset.common
                    ? `${dataUrlBase}/${courseId}/_common/`
                    : `${dataUrl}assets/`
                }${localizedFile}`
              );
            } else {
              dispatch({
                type: 'SHOW_IFRAME',
                icon: asset.subtype === 'lab' ? 'activities' : 'file-pdf-o',
                title: asset.description,
                hideOpen,

                callback: e => {
                  // if HTML lab
                  if (localizedFile.includes('.html')) {
                    // get the iframe html content
                    let iframeDocument =
                      e.target.contentDocument ||
                      e.target.contentWindow.document;
                    let uiStringScript = document.createElement('script');
                    let textMapping =
                      "var TXT_showAnswer = '" +
                      t('Lab.showAnswer') +
                      "'; var TXT_hideAnswer = '" +
                      t('Lab.hideAnswer') +
                      "'; var TXT_showAllAnswers = '" +
                      t('Lab.showAllAnswers') +
                      "'; var TXT_hideAllAnswers = '" +
                      t('Lab.hideAllAnswers') +
                      "'; var TXT_clearMyAnswers = '" +
                      t('Lab.clearMyAnswers') +
                      "'; var TXT_exportMyAnswers = '" +
                      t('Lab.exportMyAnswers') +
                      "'; var TXT_showConfig = '" +
                      t('Lab.showConfig') +
                      "'; var TXT_hideConfig = '" +
                      t('Lab.hideConfig') +
                      "';  var TXT_clearDrawing = '" +
                      t('Lab.clearDrawing') +
                      "';  var TXT_placeholder = '" +
                      t('Lab.placeholder') +
                      "';";
                    let newInlineScript = document.createTextNode(textMapping);
                    uiStringScript.appendChild(newInlineScript);
                    iframeDocument.head.appendChild(uiStringScript);
                    // get the window object of the iframe
                    let iframeWindow = e.target.contentWindow;
                    // create a script tag
                    let script = document.createElement('script');
                    script.src = './icons/fixer.js';
                    script.type = 'text/javascript';
                    // after the script is loaded...
                    script.onload = () => {
                      // call the init() function
                      iframeWindow.init();
                    };
                    // append script tag to the lab HTML's head
                    iframeDocument.head.appendChild(script);
                  }
                },
                url: `${
                  asset.common
                    ? `${dataUrlBase}/${courseId}/_common/`
                    : `${dataUrl}assets/`
                }${localizedFile}`
              });
            }
          }}
        >
          <span
            className={
              asset.subtype === 'lab' ? 'icon-activities' : 'icon-file-pdf-o'
            }
          ></span>{' '}
          {asset.description}
        </button>
      ) : (
        <span className="text--danger">PDF asset not found</span>
      )}
    </div>
  );
};

export default Pdf;
